<template>
  <template v-if="content !== null">
    <div v-if="!big" class="cursor-default truncate" :data-tint="color">
      <span
        class="squircle-md bg-primary text-contrast-primary flex justify-center gap-1 rounded-md px-1 py-0.5"
      >
        <FontAwesomeIcon v-if="icon" :icon="['fal', icon]" />
        <span v-if="content" class="capitalize-first truncate">
          {{ content }}
        </span>
      </span>
    </div>

    <div
      v-else
      :data-tint="color"
      class="bg-primary text-contrast-primary flex truncate rounded-md px-4 py-2.5 select-none"
      aria-expanded="false"
    >
      <FontAwesomeIcon v-if="icon" :icon="['fal', icon]" />
      <span v-if="content" class="capitalize-first truncate">
        {{ content }}
      </span>
    </div>
  </template>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default {
  name: 'BaseLabel',
  components: { FontAwesomeIcon },
  props: {
    content: { type: String, required: true },
    color: { type: String, required: false, default: '' },
    icon: { type: String, required: false, default: '' },
    big: { type: Boolean, required: false, default: false }
  },
  computed: {
    colorClass() {
      return this.color === '' ? 'bg-slate-300' : `bg-theme-${this.color}`
    }
  }
}
</script>
